export default "__VITE_ASSET__wSZkyx90__"